import i18n from 'i18next';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { routeFileSelector } from '../../../../../utilz/i18n';
import FormSelectBox from '../../../../components/Inputs/FormSelectBox';
import { useGetShipmentTerms } from '../../hooks';

export const ShipmentTermsSelect = ({
  placeholder = i18n.t('translation:default.fields.shipmentTerms.placeholder'),
  label = i18n.t('translation:default.fields.shipmentTerms.label'),
  rules = [],
  name,
  editMode,
  margin,
  tooltip = false,
  isDefault = false,
  disableValidation = false,
  onChange,
  disableDefaultOptions = false,
}) => {
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);

  const { data: options = [], isLoading } = useGetShipmentTerms();

  return (
    <FormSelectBox
      loading={isLoading}
      options={
        !disableDefaultOptions
          ? isDefault === true
            ? [{ label: t('translation:default.buttons.select'), value: '' }, ...options]
            : [
                {
                  label: `--${t('translation:default.options.all')}--`,
                  value: '',
                },
                ...options,
              ]
          : options
      }
      placeholder={placeholder}
      label={label}
      rules={rules}
      name={name}
      editMode={editMode}
      margin={margin}
      tooltip={tooltip}
      disableValidation={disableValidation}
      onChange={onChange}
    />
  );
};
